export const navigationAddresses = [
  {
    id: "addr-1",
    label: "官方主线路",
    url: "https://www.aiqingdao.com",
    status: "normal",
    speed: "快速",
    updatedAt: "2026-08-05",
    description: "爱情岛论坛官方主入口，推荐优先使用此地址访问",
  },
  {
    id: "addr-2",
    label: "备用线路一",
    url: "https://www.aiqingdao.com/mirror1",
    status: "normal",
    speed: "稳定",
    updatedAt: "2026-08-04",
    description: "当主线路访问缓慢或不可用时，可尝试此备用地址",
  },
  {
    id: "addr-3",
    label: "备用线路二",
    url: "https://www.aiqingdao.com/mirror2",
    status: "normal",
    speed: "较快",
    updatedAt: "2026-08-03",
    description: "第三备用访问线路，适用于部分地区网络环境",
  },
  {
    id: "addr-4",
    label: "海外专线",
    url: "https://www.aiqingdao.com/global",
    status: "normal",
    speed: "极速",
    updatedAt: "2026-08-02",
    description: "面向海外用户优化的访问线路，跨境访问更顺畅",
  },
  {
    id: "addr-5",
    label: "移动端入口",
    url: "https://m.aiqingdao.com",
    status: "normal",
    speed: "快速",
    updatedAt: "2026-08-05",
    description: "适配手机浏览器的移动端专属入口地址",
  },
];

export const quickLinks = [
  { label: "最新地址", href: "/category/zuixin-dizhi" },
  { label: "线路更新", href: "/category/xianlu-gengxin" },
  { label: "使用指南", href: "/category/shiyong-zhinan" },
  { label: "常见问题", href: "/category/changjian-wenti" },
  { label: "安全防护", href: "/category/anquan-fanghu" },
];